import http from '../../httpService';

export function deleteDepartments(id) {
  return http.delete(`/departments/${id}`);
}